// extracted by mini-css-extract-plugin
module.exports = {"staticPageWrapper":"BecomeAHostPage_staticPageWrapper__32-oQ"};